import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button, Alert } from 'shpmtcd'

const formValidationResult = (isValid, message) => {
  if (!isValid) {
    return <Alert type='error' message={message} showIcon />
  }
  return null
}

const submitHandler = (isFormValid, onSubmit, e) => {
  e.preventDefault()
  if (isFormValid) {
    onSubmit(e)
  }
}

class LoginForm extends Component {
  componentDidMount() {
    const { email, password, onMount } = this.props
    if (email.value.length && password.value.length) onMount()
  }

  render() {
    const {
      email, password, isFormValid, showFormValidationResult, formValidationMessage,
      onEmailChange, onPasswordChange, onSubmit, isNewUser,
    } = this.props
    const isButtonEnabled = email.isValid && password.isValid
    return (
      <form className='login-form' onSubmit={(e) => { submitHandler(isFormValid, onSubmit, e) }} noValidate>
        <Input
          label='Email address'
          className='email-field'
          error={email.validationMessages.toString()}
          onChange={onEmailChange}
        />
        <Input
          label='Password'
          type='password'
          className='password-field'
          error={password.validationMessages.toString()}
          onChange={onPasswordChange}
        />
        {
          showFormValidationResult && formValidationMessage
            ? formValidationResult(isFormValid, formValidationMessage)
            : null
        }
        <Button
          type='Primary'
          block
          className='submit-btn'
          onClick={(e) => { submitHandler(isFormValid, onSubmit, e) }}
          disabled={!isButtonEnabled}
        >
          {isNewUser ? 'Register' : 'Sign in'}
        </Button>
      </form>
    )
  }
}

export default LoginForm

LoginForm.propTypes = {
  email: PropTypes.shape({
    value: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    validationMessages: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  password: PropTypes.shape({
    value: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    validationMessages: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  showFormValidationResult: PropTypes.bool,
  formValidationMessage: PropTypes.string,
  isFormValid: PropTypes.bool,
  onEmailChange: PropTypes.func.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onMount: PropTypes.func.isRequired,
  isNewUser: PropTypes.bool.isRequired,
}

LoginForm.defaultProps = {
  showFormValidationResult: false,
  formValidationMessage: '',
  isFormValid: false,
}
